import AmellisHealth from "./AmellisHealth";
import Health from "./Health";
import LmfHealth from "./LmfHealth";
import MutualMobility from "./MutualMobility";
import SmartPhone from "./SmartPhone";
import SoLyonHealth from "./SoLyonHealth";
import Miltis from "./Miltis";
import SNCA from "./SNCA";

const Templates = {
  Health,
  SmartPhone,
  SoLyonHealth,
  LmfHealth,
  MutualMobility,
  AmellisHealth,
  Miltis,
  SNCA,
};

export default Templates;
